import { Attribute, DateDisplay } from '../../../../../../components/core-v2'
import { NewNoteState } from '../../../01-note/new-note/validation-rules'
import { NoteStepState } from '../../../01-note/note/note-step-slice'
import { ApprovalBox } from '../../molecules/approval-box'
import { ConfirmationBox } from '../../molecules/confirmation-box'
import { ApprovalProps } from './types'

type Props = ApprovalProps & {
  newNote: NewNoteState
  note: NoteStepState
}

export const ApproveNote = ({
  isApproved,
  newNote,
  note,
  onChangeIsApproved,
  onClickEdit
}: Props) => (
  <ApprovalBox isApproved={isApproved} title="Note">
    <Attribute data-private name="Client">
      {!note.client ? newNote.note.client.clientName : note.client.clientName}
    </Attribute>

    <Attribute data-private name="Business unit">
      {!note.businessUnit
        ? newNote.note.businessUnit.businessUnitName
        : note.businessUnit.businessUnitName}
    </Attribute>

    <Attribute name="Name">{note.note.noteName}</Attribute>

    <Attribute name="Note ID (Stock code)">{note.note.noteId}</Attribute>

    <Attribute name="Start date">
      <DateDisplay value={note.note.startDate} />
    </Attribute>

    {note.note.endDate && (
      <Attribute name="Maturity date">
        <DateDisplay value={note.note.endDate} />
      </Attribute>
    )}

    <Attribute name="Distribution processing">{note.note.dividendProcessing}</Attribute>

    <Attribute name="Note type">{note.note.taxClassification}</Attribute>

    <Attribute name="Collateral for loan">{note.note.isCollateralForLoan ? 'Yes' : 'No'}</Attribute>

    <ConfirmationBox
      elementTitle="Note"
      isApproved={isApproved}
      isAre="is"
      onChangeIsApproved={onChangeIsApproved}
      onClickEdit={onClickEdit}
    />
  </ApprovalBox>
)
